import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'

import Grid from '@material-ui/core/Grid'
import GetApp from '@material-ui/icons/GetApp'
import CircularProgress from '@material-ui/core/CircularProgress'

import config from '../../../../config'
import { AppState } from '../../../../store'

import {
  getDocumentById,
  statusDocument,
  postDocumentMessage
} from '../../store/actions'

import { getKeyByValue, dateCurrent, downloadDocument } from '../../../../utils'

import {
  DocumentEditResponse,
  Document_DocumentTypesToGet_documentTypeFields,
  DocumentStatusType,
} from '../../models/interfaces'

import {
  IButton,
  ParagraphTitle,
  Container,
  StatusColor,
  ButtonSend,
  ParagraphTitleMessage
} from '../../../../styles/styles'

const DocumentDetail: React.FC = () => {
  const [Document, setDocument] = useState<DocumentEditResponse>()
  const authType: string = useSelector(
    (state: AppState) => state.Authorization.authType
  )
  const isLoading = useSelector((state: AppState) => state.Document.isLoading)

  const { id } = useParams<{id: string}>()
  const history = useHistory()

  useEffect(() => {
    if (id) {
      getDocumentById(parseInt(id))
        .then((res: DocumentEditResponse) => {
          setDocument(res)
        })
        .catch(err => {
          console.log(err)
          Swal.fire({
            title: 'Erro',
            text: `Ocorreu algum erro ao carregar os dados`,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000
          })
          history.push('document/list')
        })
    }
  }, [id, history])

  const putStatus = async (res: any, status: DocumentStatusType) => {
    if (res.value) {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Adicionado Status',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: async () => {
          Swal.showLoading()

          let response = false
          if (typeof id != 'undefined') {
            response = await statusDocument(parseInt(id), status)
          }

          if (response) {
            Swal.fire(
              'Statuso adicionado',
              'O Status do docuemnto foi adicionado com sucesso!',
              'success'
            )

            if (Document) {
              setDocument({
                ...Document,
                Document: { ...Document?.Document, status }
              })
            }
          } else {
            Swal.fire({
              title: 'Erro',
              text: `Ocorreu algum erro ao executar a ação!`,
              icon: 'error',
              showConfirmButton: false,
              timer: 2000
            })
          }
        }
      })
    }
  }

  const confirmStatus = async (status: DocumentStatusType) => {
    Swal.fire({
      title: 'Confirmação',
      html: 'Você tem certeza que deseja adicionado esse status ao documento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then((res: any) => {
      if(res.value){
        if (status === DocumentStatusType.Reprovado) {
          Swal.fire({
            title: 'Informe o motivo para estar recusando o documento',
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async (message: string) => {
              if(message.length > 0){
               const resPostMessage = await postDocumentMessage(parseInt(id), message);
                if(resPostMessage){
                  return putStatus(res, status);
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading()
          })
        } else {
          return putStatus(res, status)
        }
      }
    })
  }

  return (
    <React.Fragment>
      <Container background='#E2E4E6'>
        <Container background='#fff'>
          {isLoading && (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress size={25} />
            </div>
          )}
          {!isLoading && (
            <React.Fragment>
              <div style={{ flexDirection: 'row', display: 'flex' }}>
                <div style={{ flex: 1, margin: 10 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <ParagraphTitle>Status:</ParagraphTitle>
                      <b style={{ fontSize: 20 }}>
                        <StatusColor
                          status={getKeyByValue(
                            DocumentStatusType,
                            Document?.Document.status
                          )}
                        />
                      </b>
                    </Grid>
                    <Grid item xs={12}>
                      <ParagraphTitle>Tipo de Documento:</ParagraphTitle>
                      {Document?.providerDocumentFields.name}
                    </Grid>
                    {Document?.Document.fileName && (
                      <Grid item xs={12}>
                        <ParagraphTitle>Arquivo:</ParagraphTitle>
                        {Document?.Document.fileName}
                        <br />
                        <br />
                        <GetApp
                          style={{ fontSize: 35, cursor: 'pointer' }}
                          onClick={() => {
                            Document.Document.fileName &&
                              Document.Document.id &&
                              downloadDocument(
                                Document.Document.fileName,
                                Document.Document.id
                              )
                          }}
                        />
                      </Grid>
                    )}
                    {Document?.Document.description && (
                      <Grid item xs={12}>
                        <ParagraphTitle>Descrição:</ParagraphTitle>
                        {Document?.Document.description}
                      </Grid>
                    )}
                    {Document?.Document.message && (
                      <Grid item xs={12}>
                        <ParagraphTitleMessage>
                          Mensagem da Central:
                          <p>{Document?.Document.message}</p>
                        </ParagraphTitleMessage>
                      </Grid>
                    )}
                    {Document?.Document.expirationDate && (
                      <Grid item xs={6}>
                        <ParagraphTitle>Válidade:</ParagraphTitle>
                        {dateCurrent(
                          'pt-BR',
                          Document?.Document.expirationDate
                        )}
                      </Grid>
                    )}

                    {authType === config.userTypeAdmin &&
                      Document?.Document.status ===
                        DocumentStatusType.Pendente && (
                        <Grid item xs={9}>
                          <p style={{ color: '#888' }}>
                            Selecione o status do documento:
                          </p>
                          <IButton
                            width={90}
                            background='#52D126'
                            type='submit'
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              confirmStatus(DocumentStatusType.Aprovado)
                            }
                          >
                            APROVAR
                          </IButton>
                          <IButton
                            width={90}
                            background='#D12626'
                            type='submit'
                            style={{ marginRight: 10 }}
                            onClick={() =>
                              confirmStatus(DocumentStatusType.Reprovado)
                            }
                          >
                            RECUSAR
                          </IButton>
                          <IButton
                            width={210}
                            background='#2196f3'
                            type='submit'
                            // style={{ width: '45%' }}
                            onClick={() =>
                              confirmStatus(
                                DocumentStatusType.PendenteFornecedor
                              )
                            }
                          >
                            PENDENTE FORNECEDOR
                          </IButton>
                        </Grid>
                      )}
                  </Grid>
                </div>
                <div style={{ flex: 1, margin: 10 }}>
                  <Grid container spacing={2}>
                    {Document?.providerDocumentFields.documentTypeFields.map(
                      (
                        element: Document_DocumentTypesToGet_documentTypeFields,
                        index: number
                      ) => (
                        <Grid item xs={12} key={index}>
                          <ParagraphTitle>{element.description}</ParagraphTitle>
                          {element.answer.value}
                        </Grid>
                      )
                    )}
                  </Grid>
                </div>
              </div>
              <ButtonSend>
                <IButton
                  width={130}
                  background='#26B2D1'
                  type='button'
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    history.goBack()
                  }}
                >
                  VOLTAR
                </IButton>
              </ButtonSend>
            </React.Fragment>
          )}
        </Container>
      </Container>
    </React.Fragment>
  )
}

export default DocumentDetail
